import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";

function Newsletter_35() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter August 2025
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            UK Releases Draft Sustainability Standards to Drive Rigorous Climate
            and ESG Disclosures. .
          </title>
          <meta
            name="description"
            content="The UK government has published draft sustainability reporting standards designed to elevate the quality and consistency of corporate ESG disclosures."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          ESMA Issues New Guidelines to Curb Misleading ESG Claims Across
          Financial Markets.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Aug_2025_1.webp")}
            alt="ESMA Issues New Guidelines to Curb Misleading ESG Claims Across Financial Markets."
            loading="lazy"
          />
        </figure>
        <p>
          The European Securities and Markets Authority has released new
          guidance to address the growing risk of greenwashing by tightening
          expectations around how financial institutions communicate
          sustainability-related claims. The guidance outlines four key
          principles that all sustainability communications must meet: they must
          be accurate, accessible, substantiated, and kept up to date. This
          applies across the investment value chain, including asset managers,
          issuers, and benchmark administrators, with a focus on ensuring that
          investors receive fair and clear information when evaluating ESG
          products and services.
        </p>
        <p>
          The note places particular emphasis on ESG credentials such as labels,
          ratings, and industry affiliations, which are often used in marketing
          materials but lack consistent standards. ESMA warns against
          overstating the value of credentials, referencing outdated awards, and
          selectively presenting favourable data. Clear explanation of what a
          credential means, how it is earned, who awards it, and whether it is
          monitored over time is now considered essential. Claims must not rely
          on vague or irrelevant details and must be contextualised properly to
          avoid misleading investors.
        </p>
        <p>
          With sustainable investment assets expected to surpass fifty trillion
          dollars globally by 2025, the pressure on regulators to ensure
          credibility and integrity in ESG markets is rising. ESMA’s move
          reinforces the EU’s broader agenda to build investor confidence in
          sustainable finance by holding firms accountable for the accuracy and
          transparency of their sustainability messaging.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            To align with ESMA’s expectations, funds must embed ESG integrity
            deep within their disclosure architecture. This means moving beyond
            surface-level narratives to build traceable, criteria-driven
            validation for every sustainability claim. Abstracting ESG into
            quantifiable signals, ensuring cross-functional governance, and
            stress-testing communications against evolving benchmarks will be
            key. Preparedness lies not in compliance alone, but in curating ESG
            narratives that are dynamic, data-hardened, and immune to regulatory
            and reputational fragility.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          ECB Aligns Monetary Policy with Climate Risk Through Collateral
          Adjustments
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/Aug_2025_2.webp")}
              alt="ECB Aligns Monetary Policy with Climate Risk Through Collateral Adjustments"
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          The European Central Bank is updating its collateral framework to
          integrate climate transition risks more directly. A new climate factor
          will adjust the value of assets pledged by banks in refinancing
          operations. Assets exposed to significant climate transition risks
          will face higher haircuts. This move is aimed at protecting the
          Eurosystem from climate-related financial instability while
          maintaining adequate collateral availability. The measure will apply
          to marketable corporate bonds from non-financial companies and is set
          for implementation in the second half of 2026. Calibration will rely
          on data from the 2024 ECB climate stress test and issuers’ climate
          scores.
        </p>
        <p>
          The ECB has also expanded its financial disclosures to include an
          indicator assessing exposure to nature-intensive sectors such as
          utilities, food, and real estate. Nearly 30 percent of the central
          bank’s corporate bond holdings fall into these categories. While
          overall emissions from ECB portfolios are declining, the data reveals
          persistent systemic risks linked to biodiversity loss and
          environmental degradation.
        </p>
        <p>
          Climate risks are becoming more material. Research shows that
          prolonged droughts and extreme weather events could shrink Eurozone
          GDP by up to 15 percent without strong policy responses. Banks
          currently hold around 1.3 trillion euros in loans to water-sensitive
          industries. More than 90 percent of Eurozone banks now acknowledge
          climate and environmental risk in their frameworks, and supervisors
          are enforcing stricter climate risk integration. Institutions that
          fall short may face binding regulatory measures.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The ECB’s climate-based collateral rules will directly affect how
            banks manage their asset portfolios. Institutions holding
            carbon-intensive bonds will face stricter refinancing terms, which
            may reduce their access to central bank funding. This will likely
            prompt banks to increase lending to lower-risk, climate-aligned
            sectors. Over time, it will change credit allocation patterns and
            increase pressure on banks to improve climate risk disclosures and
            strategies.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          California Publishes Key FAQ on Corporate Climate Risk and Emissions
          Reporting
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Aug_2025_3.webp")}
            alt="California Publishes Key FAQ on Corporate Climate Risk and Emissions Reporting"
            loading="lazy"
          />
        </figure>
        <p>
          California has taken a major step in advancing corporate climate
          accountability by releasing a comprehensive Frequently Asked Questions
          document. This guidance supports businesses preparing to comply with
          two sweeping climate disclosure laws: the Climate Corporate Data
          Accountability Act and the Climate-Related Financial Risk Disclosure
          Act. These statutes apply to companies with over one billion dollars
          and five hundred million dollars in annual revenue, respectively, that
          are doing business in California. The laws require reporting on
          greenhouse gas emissions starting in 2026 and climate-related
          financial risks beginning January 1, 2026. This move places California
          at the forefront of climate regulation in the United States, setting a
          precedent for transparent, data-driven corporate accountability.
        </p>
        <p>
          The FAQ, published by the California Air Resources Board (CARB), is
          organized into two main categories. The first section, Regulatory
          Development, outlines how CARB is transitioning from legislative
          mandates to final regulation. It addresses CARB’s goals of building a
          California-specific framework while aligning with global standards
          like the Task Force on Climate-related Financial Disclosures (TCFD).
          This section also explains the applicability of the laws, including
          definitions for "doing business in California," revenue thresholds,
          and the treatment of parent and subsidiary companies. CARB is actively
          seeking public feedback on these definitions to ensure clarity and
          consistency before finalizing the rules.
        </p>
        <p>
          The second section, Initial Reports, provides detailed guidance on the
          reporting timelines, verification requirements, and expectations for
          good faith compliance. Companies must begin reporting Scope 1 and 2
          emissions in 2026, based on prior-year data, with Scope 3 reporting
          phased in from 2027. These disclosures will require third-party
          assurance, starting with limited assurance in 2026 and progressing to
          reasonable assurance by 2030. For climate risk reports, companies must
          publish findings by January 1, 2026, and update them biennially. CARB
          is also creating a centralized public docket, open from December 1,
          2025, to July 1, 2026, where companies must post the location of their
          risk reports to ensure accessibility and transparency.
        </p>
        <p>
          The FAQ is part of CARB’s broader strategy to ease companies into
          compliance without compromising rigor. The guidance allows flexibility
          in early years, encouraging companies to use existing data systems
          while ramping up internal capacity.{" "}
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            By aligning with global frameworks and offering phased compliance,
            California’s disclosure rules help companies futureproof their
            operations against regulatory and market risks. The structured
            reporting process enhances investor confidence, sharpens internal
            climate risk assessment, and builds reputational equity. It
            encourages firms to integrate sustainability into core strategy, not
            just for compliance but as a lever for long term value creation in
            an increasingly carbon conscious economy.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Australia Expands Capacity Investment Scheme to 40 GW for Renewable
          Growth.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Aug_2025_4.webp")}
            alt="Australia Expands Capacity Investment Scheme to 40 GW for Renewable Growth."
            loading="lazy"
          />
        </figure>
        <p>
          Australia has increased its Capacity Investment Scheme to 40 GW,
          aiming to deliver 26 GW of new renewable generation and 14 GW of
          dispatchable storage capacity by 2030. This expanded target is
          expected to drive approximately AUD 73 billion in private investment
          across wind, solar, and battery storage projects. The initiative is a
          key part of Australia’s broader plan to achieve 82 percent renewable
          electricity by the end of the decade, supporting national energy
          security while cutting emissions from the power sector.
        </p>
        <p>
          The increase follows six competitive tender rounds that have already
          secured commitments for 18 GW of clean energy projects. Each round has
          attracted strong investor interest, confirming that the market sees
          long-term value in Australia’s renewable energy transition. The scheme
          also creates opportunities for job growth, industry development, and
          regional economic benefits by encouraging the construction of new
          energy infrastructure across multiple states and territories.
        </p>
        <p>
          Early investment trends in 2025 show growing momentum, particularly in
          battery storage. More than AUD 2.4 billion was committed in the first
          quarter alone, financing over 1.5 GW of new storage capacity. In
          total, more than 80 renewable energy projects with a combined capacity
          of 12 GW are now under construction or financially committed. These
          developments mark steady progress toward a cleaner, more resilient
          national energy system that can meet future demand with lower
          emissions and greater reliability.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The expansion of the Capacity Investment Scheme will ripple far
            beyond the energy sector, influencing how industries manage risk,
            capital, and supply chains. Heavy industries will find new
            incentives to electrify operations, while finance and infrastructure
            sectors will recalibrate around long-term clean energy exposure. It
            signals a structural shift, embedding decarbonisation into the core
            logic of industrial strategy and investment planning across the
            economy.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          IFRS Foundation Issues Near Final Climate Related Examples to Guide
          Reporting of Uncertainties in Financial Statements.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/Aug_2025_5.webp")}
            alt="IFRS Foundation Issues Near Final Climate Related Examples to Guide Reporting of Uncertainties in Financial Statements."
            loading="lazy"
          />
        </figure>

        <p>
          IFRS Foundation released a near-final set of six illustrative examples
          designed to guide companies in disclosing climate-related
          uncertainties within their financial statements. Developed in
          collaboration with the International Sustainability Standards Board
          (ISSB), the examples reflect increasing global demand for consistent,
          transparent, and decision-useful climate risk disclosures. As
          financial markets integrate environmental risk into capital
          allocation, this move strengthens the connection between financial
          reporting and real-world climate exposure.
        </p>
        <p>
          The examples provide practical guidance for companies navigating
          complex areas where climate factors influence financial judgment.
          These include impairment testing assumptions like future carbon
          pricing, materiality assessments for transition plans, credit risk
          exposure tied to climate-sensitive sectors, and provisions related to
          asset decommissioning under evolving regulations. They also recommend
          disaggregating property, plant, and equipment based on differing
          climate vulnerabilities, highlighting the need for more granular
          disclosures across industries and geographies.
        </p>
        <p>
          Importantly, companies are encouraged to disclose climate-related
          information even when there is no immediate effect on recognition or
          measurement, especially if users of financial statements would benefit
          from understanding the risks and assumptions involved. This guidance
          pushes entities to apply a forward-looking lens, strengthening
          investor confidence in the resilience of financial statements amid
          environmental uncertainty. It also underlines the need to align
          financial reports with broader sustainability narratives.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The early release provides companies with a head start in preparing
            for implementation. Organizations are encouraged to assess their
            existing reporting frameworks, identify and address disclosure gaps,
            and ensure their financial statements align with the evolving
            expectations of regulators, investors, and global stakeholders.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_35;
